import p4 from "@/assets/restore/social/post-4.webp";
import p8 from "@/assets/restore/social/post-8.webp";
import p10 from "@/assets/restore/social/post-10.webp";
import p11 from "@/assets/restore/social/post-11.webp";
import p12 from "@/assets/restore/social/post-12.webp";
import p13 from "@/assets/restore/social/post-13.webp";
import s1 from "@/assets/restore/social/post-social-1.webp";
import p23 from "@/assets/restore/social/post-23.webp";
import p30 from "@/assets/restore/social/post-30.webp";
import s2 from "@/assets/restore/social/post-social-2.webp";
import p33 from "@/assets/restore/social/post-33.webp";
import p44 from "@/assets/restore/social/post-44.webp";

const POSTS = [p4, p8, p10, p11, p12, p13, s1, p23, p30, s2, p33, p44];

const IG = "https://www.instagram.com/restore_hair/";

export function SocialPosts() {
  return (
    <section className="bg-background py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="text-center text-2xl md:text-3xl font-bold text-foreground">
          Get Social with <span className="text-primary">RESTORE<sup>®</sup></span>
        </h2>
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {POSTS.map((src, i) => (
            <a
              key={src}
              href={IG}
              target="_blank"
              rel="noopener noreferrer"
              className="block overflow-hidden"
            >
              <img
                src={src}
                alt={`RESTORE Hair social post ${i + 1}`}
                loading="lazy"
                className="aspect-square w-full object-cover transition hover:opacity-90"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
